;
export var buildSource = function (id, type) {
    return { id: id, type: type };
};
//# sourceMappingURL=source.i.js.map